import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { motion } from "framer-motion";

const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Espanol" },
  { code: "fr", label: "Francais" },
  { code: "pt", label: "Portugues" },
];

const LanguageSection = ({ currentLang, onChange }) => (
  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.32 }}>
    <Card className="glass" data-testid="language-settings-card">
      <CardHeader>
        <CardTitle className="text-lg text-white flex items-center gap-2">
          <Globe className="w-5 h-5 text-mystic-300" />
          Language / Idioma
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex gap-3 flex-wrap">
          {LANGS.map(lang => (
            <Button
              key={lang.code}
              onClick={() => onChange(lang.code)}
              variant={currentLang === lang.code ? "default" : "outline"}
              className={`rounded-full ${
                currentLang === lang.code
                  ? "bg-purple-600 text-white"
                  : "border-white/20 text-mystic-200"
              }`}
              data-testid={`lang-${lang.code}-btn`}
            >
              {lang.label}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  </motion.div>
);

export default LanguageSection;
